import type { QueryView } from '@krp/client-runtime'

import { AQSI_RIGHTS } from '../../../shared/model/rights'

/** Право вкладки цен AQSI: видеть снимок товаров кабинета — тот же, что у каталога. */
export const PRICES_CAPABILITY = AQSI_RIGHTS.catalogRead

/** Право задавать цену карточки кабинета: без него вкладка только показывает цены. */
export const PRICES_WRITE_CAPABILITY = AQSI_RIGHTS.pricesWrite

/** Намерение окна цен по rid: страница, набранный и отправленный поиск. */
export interface PricesRidIntent {
  page: number
  /** Что набрано в строке поиска. */
  search: string
  /** По чему ищет служба: набранное уходит по Enter или кнопке «Найти». */
  query: string
}

export interface PricesIntentState {
  byResource: Record<string, PricesRidIntent>
}

/** Строка списка цен кабинета: товар, у которого цена есть. */
export interface PriceRowVm {
  goodId: string
  name: string
  sku: string
  barcodes: string
  /** «89,90 ₽»; у товара без цены — «нет цены». */
  price: string
  hasPrice: boolean
  state: string
  stateKind: 'ok' | 'missing' | 'invalid'
}

/**
 * «Цены AQSI» (таблица замечаний 13.10.2026, п. 6): прайс кабинета — цена карточки каждого товара из снимка
 * каталога службы. Вид цены в кабинете один, выбора нет.
 */
export interface PricesVm {
  query: QueryView
  rows: readonly PriceRowVm[]
  /** «Цены кассы на 14:32: 1 250 товаров»; пусто — снимок не прочитан. */
  snapshot: string
  search: string
  /** Поиск применён: выдача отобрана по `searchedText`. */
  searchedText: string | null
  page: number
  pageCount: number
  total: number
  /** Товары загружаются из кабинета прямо сейчас. */
  refreshing: boolean
  busy: boolean
  notice: { kind: 'done' | 'failed'; text: string } | null
}

export interface PricesActions {
  searchChanged: (text: string) => void
  submitSearch: () => void
  clearSearch: () => void
  setPage: (page: number) => void
  refresh: () => void
  retry: () => void
}
